import { Component, OnInit } from '@angular/core';
import { GeneralEditFormComponent } from './general-edit-form/general-edit-form.component';
import { LanguageEditFormComponent } from './language-edit-form/language-edit-form.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DataTableComponent } from '../datatable/datatable.component';
import { AppService } from '../../services/app.service';
import { MasterService } from '../../services/master.service';
import { Datatable } from '../../models/datatable.model';
import { PageAccessEditFormComponent } from './page-access-edit-form/page-access-edit-form.component';
import { DashboardTilesEditFormComponent } from './dashboard-tiles-edit-form/dashboard-tiles-edit-form.component';
import { SharedService } from '../../services/shared'; 

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent implements OnInit {
public data;
editFormDialogRef: MatDialogRef<GeneralEditFormComponent>;
languageFormDialogRef: MatDialogRef<LanguageEditFormComponent>;
pageaccessFormDialogRef: MatDialogRef<PageAccessEditFormComponent>;
dashboardTilesFormDialogRef: MatDialogRef<DashboardTilesEditFormComponent>;
translations: any;
public length;
pageIndex: Number = 0;
pageSize: Number = 10;
filterText: String = '';
sortDirection: String = 'asc';
sortHeaderName: String = 'Code';
sortColumnNameById: String = 'Code';
  
constructor(
private generalService: MasterService,
public appService: AppService,
private datatableComponent: DataTableComponent,
public dialog: MatDialog,
private datatableProp: Datatable,
private sharedService: SharedService
) {
    this.setPageTranslations();
    this.appService.showLoading();
    this.appService.checkSession();
    this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
}

setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
}

ngOnInit() {
}

getGeneralRecordsByType(typeId): void {
  this.appService.showLoading();
  this.generalService.all(typeId,this.pageIndex,this.pageSize,this.sortColumnNameById,this.sortDirection,this.filterText).subscribe(
     res => this.getAllGeneralSuccess(res),
     error => this.apiFaillure(error)
  );
}

getAllGeneralSuccess(res): void {
    this.data = [];
    if (res.Status == 1) {
    this.data = JSON.parse(res.Data).Table;
    
    this.datatableProp = this.appService.mapDataTableProp(this.datatableProp,JSON.parse(res.Data).Table1[0]);
    if(this.data != null && this.data != undefined){
        if(this.data.length > 0){
            if(this.data[0].HasParent == false){
                this.datatableProp.displayedColumns.splice(2,1);
            }
        }
    }
    this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
    this.length = this.data.length == 0 ? 0 : JSON.parse(res.Data).Table[0].MaxRowNumber;
    this.sharedService.Data.next(this.data);
    this.datatableProp.columnKeyData = JSON.parse(res.Data).Table3;
    //this.datatableProp.iscustom = true;
    //this.datatableProp.gridName = "general";
    this.appService.hideLoading();
    } else if (res.Status == -1) {
    this.apiFaillure(res.Message);
    }
}
apiFaillure(error): void {
  this.appService.hideLoading();
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
}

editRecord(e): void {
  this.appService.showLoading();
    this.editFormDialogRef = this.dialog.open(GeneralEditFormComponent, {
      disableClose: true,
      data: {
        Id: e.currentTarget.id,
        MasterTypeId: sessionStorage.MasterTypeId
      },
      panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed().subscribe((response) => {
      this.appService.showLoading();
      this.data = '';
      this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
    });
}

deleteRecord(e): void {
    var generalId = e.currentTarget.id;
     this.appService.showDialogue(this.translations.hdConfirm, this.translations.confrimMessage,true)
    .afterClosed().subscribe(result => {
      if (result) {
        this.appService.showLoading();
        this.deleteConfirm(generalId);
      }          
    });
  }
  
  deleteConfirm(generalId){
    this.appService.showLoading();
     this.generalService.delete(generalId).subscribe(
        res => this.deleteSuccess(res),
       error => this.apiFaillure(error)
    );
  }
  
  deleteSuccess(res){
    this.appService.hideLoading();
   if (res.Status == 1){
        this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
        .afterClosed().subscribe(result => {
            if (result) {            
            this.appService.hideLoading();
            this.data = '';
            this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
            }          
        });        
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }    
  }

addRecord(): void {
  this.appService.showLoading();
    this.editFormDialogRef = this.dialog.open(GeneralEditFormComponent, {
    disableClose: true,
    data: {
    Id: 0,
    MasterTypeId: sessionStorage.MasterTypeId
    },
    panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed()
    .subscribe((response) => {
    this.appService.showLoading();
    this.data = '';
    this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
    });
 }
 
 changeAccess(e){
  this.appService.showLoading();
    var id = e.target.getAttribute('id');
    var actionType = e.target.getAttribute('class');
    actionType = actionType.replace('mat-icon material-icons ','');
    if(actionType == 'role'){
        this.pageaccessFormDialogRef = this.dialog.open(PageAccessEditFormComponent, {
            disableClose: true,
            data: {
              Id: id
            },
            panelClass: 'my-dialog'
          });
          this.pageaccessFormDialogRef.afterClosed()
            .subscribe((response) => {
              this.appService.showLoading();
              this.data = '';
              this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
            });  
    }
    else if(actionType == 'dashtile'){
        var code = e.target.getAttribute('code');
        this.dashboardTilesFormDialogRef = this.dialog.open(DashboardTilesEditFormComponent, {
            disableClose: true,
            data: {
              Id: id,
              type: code
            },
            panelClass: 'my-dialog'
          });
          this.dashboardTilesFormDialogRef.afterClosed()
            .subscribe((response) => {
              this.appService.showLoading();
              this.data = '';
              this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
            });  
    }
    else{
    this.languageFormDialogRef = this.dialog.open(LanguageEditFormComponent, {
      disableClose: true,
      data: {
        Id: id,
        type: actionType
      },
      panelClass: 'my-dialog'
    });
    this.languageFormDialogRef.afterClosed()
      .subscribe((response) => {
        this.appService.showLoading();
        this.data = '';
        this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
      });  
    }
  }
  getServerData(event){
    this.datatableProp = new Datatable();
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
 }
 applyFilter(filterValue: any){
    this.datatableProp = new Datatable();
    this.filterText = filterValue;
    this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
 }
 getSortedData(event){
    this.datatableProp = new Datatable();
    this.sortColumnNameById = event.currentTarget.getAttribute('id');
    this.getGeneralRecordsByType(sessionStorage.MasterTypeId);
 }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/general.component.ts